import { useSaleTypeForPlan } from "@/components/features/items/edit/_shared/ui/components/main/questions/sale-type-for-plan";

import { useProductRoomFormModelContext } from "../../../../context";

export const useRoomSaleTypeForPlan = () => {
	const { viewModel, onSetViewModel } = useProductRoomFormModelContext();
	const { saleTypeForPlan } = viewModel;

	return useSaleTypeForPlan({ saleTypeForPlan, onSetViewModel });
};
